module.exports = __webpack_public_path__ + "img/Dotkit_transtions.3c7f0887.png";